const setting = {
  passwordTitle: "Contraseña",
  changePasswordBtn: "Cambiar la contraseña",
  changePasswordTips:
    "Si olvida su contraseña o quiere cambiarla, puede hacerlo aquí; le enviaremos un código de verificación a su dirección de correo electrónico registrada, que deberá ser verificada para confirmar su identidad, y luego podrá restablecer la contraseña de su cuenta.",
  feedbackTitle: "Comentarios",
  feedbackBtn: "Envíe sus comentarios",
  feedbackTips:
    "Para que podamos atenderle mejor, puede describir su problema aquí y enviarnos sus comentarios, y nuestro equipo de atención al cliente se pondrá en contacto con usted lo antes posible.",
  appearanceTitle: "Pantalla de apariencia",
  appearanceBtn: "Cambiar la pantalla",
  appearanceTips: "Elegimos dos modos de apariencia para usted, para que pueda cambiar entre los modos oscuro y claro de acuerdo a su preferencia.",
  changePassWordModalTitle: "Cambiar la contraseña",
  changePassWordSameErrorTips: "La nueva contraseña introducida es la misma que la anterior. Introduzca una contraseña diferente",
  changePasswordCurrentErrorTips: "Su contraseña es incorrecta. Inténtelo de nuevo.",
  currentPasswordLabel: "Contraseña actual",
  newPasswordLabel: "Nueva contraseña",
  retypePasswordLabel: "Reescribir la nueva contraseña",
  changePasswordSuccessTips: "Su contraseña ha sido cambiada con éxito.",
  changePasswordComfirmDiffErrorTips: "Por favor, introduzca la misma contraseña en ambos campos.",
  forgotPassword: "¿Olvidó su contraseña?",
  feedbackModalSubtitle: "Gracias por ponerse en contacto con nosotros y contarnos su opinión sobre el producto.",
  feedBackModalProductQuestion: "¿Qué tipo de problemas quiere resolver con nuestro producto?",
  feedBackModalProductTypeSug: "Sugerencias",
  feedBackModalProductTypeMem: "Preguntas relacionadas con el servicio de atención al cliente",
  feedBackModalProductTypeFun: "Consulta sobre la función",
  feedBackModalProductTypeReq: "Requisitos del producto",
  feedBackModalProductTypeBug: "Comentarios sobre errores del producto",
  feedBackModalProductTypeIss: "Cuestiones de rendimiento",
  feedBackModalProductTypeRL: "Preguntas relacionadas con el registro y el inicio de sesión",
  feedBackModalProductTypeRef: "Servicio de reembolso",
  feedBackModalProductTypeOth: "Otros",
  feedBackModalProductSelectQuestion: "¿Qué tipo de problemas quiere resolver con nuestro producto?",
  feedBackModalProductContQuestion: "¿Qué problema ha encontrado al utilizar el producto?",
  feedBackModalAddImageBtn: "Añadir imágenes",
  feedBackModalTips: "Consejos:",
  feedBackModalTipsCont:
    "Debido a la diferencia horaria del servicio global de atención al cliente, le responderemos en un plazo de 48 horas del día laborable;",
  feedBackSuccessTips: "Enviar con éxito",
  feedBackSuccessSubTips: "Resolveremos su problema lo antes posible",
  feedBackFailedTips: "No se puede enviar",
  feedBackFailedSubTips: "Por favor, asegúrese de que su conexión de red está funcionando y envíe de nuevo",
  appearanceLightMode: "Modo luz",
  appearanceDarkMode: "Modo oscuro",
  promotionModalTitle: "Promoción",
  promoItem: "Artículo promocional",
  promoCode: "Código promocional",
  discount: "Descuento",
  applyBtn: "Aplicar",
  applyPromotionErrorTips: "Su código de promoción no es válido",
};

export default setting;
